//@ts-nocheck
//@ts-ignore
/* eslint-disable */
import React from 'react';
// import './style.scss'
import { Check } from '../../components/ui/check/Check';
import { Option } from '../../components/ui/check/Option';
import { useStore } from '../../store/store';
import { useNav } from '../../hooks/nav';
import { ReactComponent as BackIcon } from '../../assets/images/arrowLeft.svg';
import Analytics from '@web-solutions/module-analytics';
import { t } from '@web-solutions/module-localization';
import { Title } from 'src/onboarding/components/typography/Title/Title';

function Page() {
  const mealsCount = useStore((state) => state.mealsCount);
  const setMealsCount = useStore((state) => state.setMealsCount);
  const { onNext, onPrev, currentIndex } = useNav();

  return (
    <div className={'page'}>
      {currentIndex !== 0 && (
        <div className={'back'} onClick={onPrev}>
          <BackIcon />
        </div>
      )}
      <div className={'wrapper-info'}>
        <Title tag='h2'>{t('onboarding.mealsCount.title')}</Title>
      </div>

      <div className={'controls'}>
        <Check
          defaultValue={mealsCount}
          onChange={(value) => {
            setMealsCount(value);
            Analytics.trackEvent(`step${currentIndex + 1}`, 'complete', {
              page: 'meals-count',
              answer: value,
            });
            onNext();
          }}
        >
          <Option value={'1'}>{t('onboarding.mealsCount.options.1')}</Option>
          <Option value={'2'}>{t('onboarding.mealsCount.options.2')}</Option>
          <Option value={'3'}>{t('onboarding.mealsCount.options.3')}</Option>
          <Option value={'4'}>{t('onboarding.mealsCount.options.4')}</Option>
          <Option value={'5+'}>{t('onboarding.mealsCount.options.5')}</Option>
        </Check>
      </div>
    </div>
  );
}
export default Page;
